<template>
    <v-layout justify-center>
        <v-responsive max-width="800" width="100%" height="100%">
            <list-heading title="계약서 양식 목록" v-model="showsSearch" showsFilterButton>
                <template #buttons>
                    <employment-form-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn icon text color="primary" v-bind="attrs" v-on="on"> <v-icon>mdi-plus</v-icon> </v-btn>
                        </template>
                    </employment-form-form>
                </template>
            </list-heading>
            <list-search-default v-bind="{ showsSearch, searchKeys }" />
            <v-data-table :headers="headers" :items="forms" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.actions`]="{ item }">
                    <employment-form-view :value="item">
                        <template #activator="{ attrs, on }">
                            <v-btn small text icon tile v-bind="attrs" v-on="on">
                                <v-icon small> mdi-eye </v-icon>
                            </v-btn>
                        </template>
                    </employment-form-view>
                    <employment-form-form :value="item" @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn small text icon tile v-bind="attrs" v-on="on">
                                <v-icon small> mdi-pencil </v-icon>
                            </v-btn>
                        </template>
                    </employment-form-form>
                    <v-btn small text icon tile @click="remove(item)">
                        <v-icon small> mdi-delete </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="mt-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list-search-default.vue";
import EmploymentFormForm from "@/components/console/employment/form/employment-form-form.vue";
import EmploymentFormView from "@/components/console/employment/form/employment-form-view.vue";

const headers = [
    { value: "name", text: "명칭" },
    { value: "createdAt", text: "생성일시", width: 110, formatter: (value) => value?.toDateTime?.() || value || "-" },
    { value: "actions", text: "", width: 116, align: "center" },
].map((item, index, array) => ({
    ...item,
    formatter: item?.formatter || ((value) => value || "-"),
    cellClass: "text-caption",
    divider: array.length - 1 !== index,
}));

const searchKeys = [
    //
    { text: "명칭", value: "name" },
];

export default {
    components: {
        ListHeading,
        ListSearchDefault,
        EmploymentFormForm,
        EmploymentFormView,
    },
    setup: () => ({
        attrs_switch,
        headers,
        searchKeys,
    }),
    data: () => ({
        forms: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,
    }),
    computed: {
        items() {
            return this.forms.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            delete query.page;

            return { ...query };
        },
    },
    mounted() {
        this.init().then(this.search);
    },
    watch: {
        params() {
            this.init().then(this.search);
        },
    },
    methods: {
        async init() {
            try {
                this.forms = [];
                this.summary = { totalCount: 0 };
            } catch (error) {
                this.$handleError(error);
            }
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { skip, limit, params } = this;
                const { summary, forms } = await api.console.employment.forms.gets({ headers: { skip, limit }, params });

                this.forms = forms;
                this.summary = summary;
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.loading = false;
            }
        },

        async update(form) {
            try {
                await api.console.employment.forms.put(form);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async remove(form) {
            let go = confirm(`"${form.name}" 계약서 양식을 삭제하시겠습니까?`);
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                await api.console.employment.forms.delete(form);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        updateItem(form) {
            const index = this.forms.findIndex(({ _id }) => _id == form._id);
            if (0 <= index) this.forms.splice(index, 1, form);
            else {
                this.forms = [form, ...this.forms];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>
